通用按钮

<template>
  <el-form-item :id="field.FIELD_ID" :ref="field.FIELD_ID" :class="itemClass" v-if="isShow" :prop="field.FIELD_ID">
    <div class="button">
      <el-button class="field-button" :disabled="isDisabled" @click="clickButton" v-html="fieldButtonTxt || '确认'">
      </el-button>
    </div>
  </el-form-item>
</template>

<script>
export default {
  data () {
    return {
      itemClass: "self-button",
      isDisabled: false,
    };
  },
  props: ["field", "index", "isBaseUI"],
  created () { },
  mounted () {
    this.itemClass += " " + this.field.FIELD_ID;
  },
  computed: {
    fieldButtonTxt: function () {
      return this.field.FIELD_TITLE;
    },
    isShow: function () {
      let fieldControl = parseInt(this.field.FIELD_CONTROL);
      if (fieldControl == 2) {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }

      if (fieldControl === 0 || fieldControl === 2) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    validatorField (rule, value, callback) { },
    clickButton () {
      if (this.isBaseUI) {
        this.$emit("click-button");
      } else {
        let data = {};
        data["MODULE_ID"] = this.field.MODULE_ID;
        data["index"] = this.index;
        data["FIELD_ID"] = this.field.FIELD_ID;
        data["GROUP_ID"] = this.$parent.$parent.$parent.moduleItem.GROUP_ID;
        this.$store.commit(this.$types.UPDATE_COMPONENT_BUTTON_CLICK, data);
      }
    },
  }
};
</script>

<style lang="less">
.self-button {
  width: 100%;
  display: flex;
  .el-form-item__label {
    font-size: 20px;
    min-width: 170px;
    text-align: right;
  }
  .el-form-item__content {
    font-size: 20px;
    color: #000;
    flex: 1;
    margin-left: 0 !important;
    width: 100% !important;
    .el-button {
      width: 220px;
      height: 80px;
      background: linear-gradient(
        45deg,
        rgba(53, 86, 221, 1),
        rgba(70, 103, 233, 1)
      );
      border-radius: 4px;
      color: #ffffff;
      border: 2px solid rgba(81, 114, 246, 1);
      font-size: 24px;
      &:hover {
        background: linear-gradient(
          45deg,
          rgba(28, 60, 189, 1),
          rgba(36, 71, 211, 1)
        );
      }
      &.is-disabled {
        background: linear-gradient(
          45deg,
          rgba(182, 194, 243, 1),
          rgba(188, 200, 247, 1)
        );
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/preEntry/normalButtonItem.vue